const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");

/* NodeJS */
module.exports = {
  getProperty: (propertyUid, language) =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/property?language=${language}&property_uid=${propertyUid}`,
      })
    ),
};